import { Route, Routes } from "react-router-dom"
import AuthorisedCategory from "./views/authorised_category"
import AuthorisedCategoryValue from "./views/authorised_category_value"
import Library from '../koha/views/library'
import ItemTypesManagement from "./views/item_types_management"
const allRouteKeys = [
    "authorized_category_management",
    "authorized_category_values_management",
    "library",
    "item_types_management",
]
const MainRoute = ({
    user_permission_data = [],
    include = allRouteKeys
}) => {
    const shouldShow = (key) => include.includes(key);

    return (<>
        <Routes>
            {/* 授權值 */}
            {shouldShow("authorized_category_management") && (
                <Route path="authorized_category_management" element={<AuthorisedCategory permission_level={user_permission_data?.map(group => group.permission_data.find(data => data.url.split("/").pop() === "authorized_category_management"))?.find(data => data !== undefined)?.permission_level_id ?? null} />} />
            )}
            {shouldShow("authorized_category_values_management") && (
                <Route path="authorized_category_values_management" element={<AuthorisedCategoryValue />} />
            )}
            {shouldShow("library") && (
                <Route path="library" element={<Library permission_level={user_permission_data?.map(group => group.permission_data.find(data => data.url.split("/").pop() === "library"))?.find(data => data !== undefined)?.permission_level_id ?? null} />} />
            )}
            {shouldShow("item_types_management") && (
                <Route path="item_types_management" element={<ItemTypesManagement permission_level={user_permission_data?.map(group => group.permission_data.find(data => data.url.split("/").pop() === "item_types_management"))?.find(data => data !== undefined)?.permission_level_id ?? null}  />} />
            )}
        </Routes>
    </>)
}
export default MainRoute